// extracted by mini-css-extract-plugin
module.exports = {"tags":"PostFooter-module--tags--37jDG","license":"PostFooter-module--license--3mgZh"};